<header class="modal-header">
  <h1 class="modal-title" i18n>Create Workspace</h1>
  <button type="button" (click)="dismiss()" aria-label="Close modal">
    <i class="cc-icon cc-icon-close sm-align-middle"></i>
  </button>
</header>
<form class="account-form" [formGroup]="accountForm" (ngSubmit)="onSubmit()">
  <div class="form-group row">
    <label class="default-label col-form-label col-sm-4" i18n>Workspace Name</label>
    <div class="col-sm-8">
      <input
        type="text"
        required
        placeholder="Text..."
        i18n-placeholder="Text..."
        formControlName="workspaceName"
        name="workspaceName"
        class="form-control"
        [class.error]="hasError('workspaceName')"
      />
      <div class="error-message" data-test="workspaceName" i18n *ngIf="hasError('workspaceName')">
        {{ errorMessageContent('workspaceName') }}
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="default-label col-form-label col-sm-4" i18n> Account Name </label>
    <div class="col-sm-8">
      <input
        type="text"
        class="form-control"
        name="accountName"
        id="account-name"
        required
        placeholder="Text..."
        i18n-placeholder="Text..."
        formControlName="accountName"
        class="form-control"
        [class.error]="hasError('accountName')"
      />
      <div class="sm-text-secondary-text sm-text-xs sm-pt-1" i18n>
        Account name is synced with Workspace name.
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="default-label col-form-label col-sm-4" i18n> Account Region </label>
    <div class="col-sm-8">
      <ng-select
        id="activate-region"
        class="activate-region"
        name="region-list"
        [items]="regions"
        bindValue="value"
        bindLabel="name"
        [clearable]="false"
        formControlName="region"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="country-option f16">
            <i class="flag-icon flag {{ item.ccode | lowercase }}"></i>
            <div>{{ item.name }}</div>
          </div>
        </ng-template>
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          <div class="country-option f16">
            <i class="flag-icon flag {{ item.ccode | lowercase }}"></i>
            <div>{{ item.name }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
  <div class="form-group row">
    <label class="default-label col-form-label col-sm-4" i18n> Account Subdomain </label>
    <div class="col-sm-8">
      <div class="sm-flex sm-items-center">
        <input
          type="text"
          class="form-control"
          name="subdomain"
          id="account-subdomain"
          required
          placeholder="Text..."
          i18n-placeholder="Text..."
          formControlName="subdomain"
          class="form-control"
          [class.error]="hasError('subdomain')"
        />
        <p class="sm-pl-1 sm-text-sm">.sitematestart.com</p>
      </div>
      <div class="error-message" data-test="subdomain" i18n *ngIf="hasError('subdomain')">
        {{ errorMessageContent('subdomain') }}
      </div>
    </div>
  </div>
  <button
    type="submit"
    class="submit-button sm-w-fit"
    [ngClass]="{ 'clickable-disabled': !accountForm.valid || loading }"
  >
    Create Account and Workspace
  </button>
</form>
